module.exports = __webpack_public_path__ + "static/media/residentialServices.86d55712.jpeg";